
// TOOLTIP
// Bootstraps "Tooltip", see Docs here: https://getbootstrap.com/docs/4.3/components/tooltips/



// Initialize Tooltips

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});



// White list Tags for use as HTML in Tooltip
// Starting from v4.3 Bootstrap used a Sanitizer for security reasons. Because Table elements are blocked since by default, they must be white listed to be used. See https://getbootstrap.com/docs/4.3/getting-started/javascript/#sanitizer

var brabusWhiteList = $.fn.tooltip.Constructor.Default.whiteList

// To allow table elements
brabusWhiteList.table = ['class']
brabusWhiteList.thead = []
brabusWhiteList.tbody = []
brabusWhiteList.tr = []
brabusWhiteList.th = ['class']
brabusWhiteList.td = ['class']
